import { useInfiniteQuery } from 'react-query';

import { useSelectedAssetId } from 'src/Hooks/Shared/useSelectedAssetId';
import { communityFeedApi } from 'src/Services/API';
import { CommunityFeedControllerCommunityFeedKindEnum } from 'src/Services/API/generated';

export type CommunityFeedKind = CommunityFeedControllerCommunityFeedKindEnum;

/**
 * Flux de la page « Entre nous », scopé au bien courant.
 * `wall` ne rend que les messages écrits par des humains, `journal` les lignes
 * générées par l'application.
 */
const useFetchCommunityFeed = (
  kind: CommunityFeedKind = CommunityFeedControllerCommunityFeedKindEnum.Wall
) => {
  const assetId = useSelectedAssetId();

  return useInfiniteQuery({
    queryKey: ['community-feed', assetId, kind],
    queryFn: async ({ pageParam = null }) => {
      return (
        await communityFeedApi.communityFeedControllerCommunityFeed(assetId!, 10, pageParam, kind)
      ).data;
    },
    enabled: !!assetId,
    getNextPageParam: lastPage => lastPage.endCursor ?? undefined,

    // Refresh the feed every minutes so we are up to date
    cacheTime: 1 * 1000,
    // We use a very low stale time : 5 seconds. If the user goes away (in its dashboard to perform actions) and go back,
    // the short stale time of 5 seconds allow to refetch the new values and display an up to date dashboard.
    staleTime: 5 * 1000,
    // Auto-refresh: poll every 15s while the tab is focused (paused when in background)
    refetchInterval: 15 * 1000,
    refetchIntervalInBackground: false,
  });
};

export default useFetchCommunityFeed;
